import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { UserService } from '../../user.service';
import { EmailValidator } from 'src/app/template/customValidators/emailValidator';
import { TranslateTextPipe } from 'src/app/shared/pipes/translateText.pipe';
import { ErrorHandlingService } from 'src/app/Services/errorHandling.service';


@Component({
  selector: 'app-gip-user-forgot-pwd',
  templateUrl: './gipUserForgotPwd.component.html',
  styleUrls: ['./gipUserForgotPwd.component.css']
})
export class GipUserForgotPwdComponent implements OnInit {

  @Output() public moveToLogin = new EventEmitter();

  constructor(
    private shareData: SharingDataService,
    private userService: UserService,
    private translateText: TranslateTextPipe,
    private errorHandlingService: ErrorHandlingService
    ) { }

    resourceDefinition;
    siteKey: string;
    recaptcharesponse = "";
    gipDefault;
    currentUser;
    Language;
    enabledNewPassword = true
    enabledRecaptcha: boolean;
    public isLoading: boolean = false;

    modelInput = new FormGroup({
      LOGIN: new FormControl('', Validators.required),
      EMAIL: new FormControl('', [Validators.required, EmailValidator, Validators.maxLength(250)]),
    });

  formular = [
    { formControlName: "LOGIN", hidden: false, readonly: false, required: true, inputString: true},
    { formControlName: "EMAIL", newRow: true, hidden: false, readonly: false, required: true, inputString: true},
  ];

  ngOnInit(): void {
    this.isNewPasswordEnabled()
    console.info(this.modelInput.status)
    this.shareData.currentResourceDefinition.subscribe((data) => this.resourceDefinition = data);
    this.shareData.currentGipDefault.subscribe((data) => this.gipDefault = data);
    this.shareData.currentUser.subscribe((data) => this.currentUser = data);
    this.shareData.currentLanguage.subscribe((data) => this.Language = data);
    this.enabledRecaptcha = this.translateText.transform("RECAPTCHAENABLED", this.gipDefault, "GIP_NAME", "GIP_VALUE") == "true" ? true : false;
    if(this.enabledRecaptcha){
      this.getSiteKey();
    }

  }

  action(action) {
    this[action]();
  }

  getSiteKey() {
    this.siteKey = this.translateText.transform("RECAPTCHASITEKEY", this.gipDefault, "GIP_NAME", "GIP_VALUE")
    this.loadScript('https://www.google.com/recaptcha/api.js');
  }

  loadScript(url) {
    var script = document.createElement('script')
    script.type = 'text/javascript';

    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  isNewPasswordEnabled() {
    return (!this.enabledRecaptcha || this.recaptcharesponse != null) && this.modelInput.status == "VALID";
  }

  resolved(event) {
    this.recaptcharesponse = event;
  }

  newPassword(){
    this.isLoading = true;
    console.log(this.recaptcharesponse);
    if(this.modelInput.status == "VALID"){
      var user = {
        EMAIL : "",
        LOGIN : "",
      };
      user.EMAIL = this.modelInput.value.EMAIL;
      user.LOGIN = this.modelInput.value.LOGIN;
      this.userService.postData(`portal/forgotpwd?recaptcharesponse=${this.recaptcharesponse}&lang=${this.Language}`, user, (data) => {
        this.modelInput.disable();
        this.moveToLogin.emit();
        this.isLoading = false;
        this.errorHandlingService.showSuccess();
      }, 
      (response) => {
        this.isLoading = false;
        
      })
    }

  }
  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
}
}






